'use strict';

angular.module('cimerFrontEndApp').controller('TrainingCurriculaCtrl', ['$location', 'Session', function ($location, Session) {
    if (!Session.getSessionObject().isAuthenticated) {
        $location.url('/');
        return;
    }
}]);